<app-tab>

  <app-dashboard-toolbar (groupSelect)="selectGroup($event)"></app-dashboard-toolbar>
  <div *ngIf="selectedGroup === 0" [@Fade]="selectedGroup === 0" class="grid p-3 grid-cols-8 gap-3">
    <app-dashboard-widget [cols]="2" [rows]="3">
      <app-example-pie-widget></app-example-pie-widget>
    </app-dashboard-widget>

    <app-dashboard-widget [cols]="2" [rows]="3">
      <app-example-bar-widget></app-example-bar-widget>
    </app-dashboard-widget>

    <app-dashboard-widget [cols]="4" [rows]="3">
      <app-example-grid-widget></app-example-grid-widget>
    </app-dashboard-widget>

    <app-dashboard-widget>
      <app-example-number-widget></app-example-number-widget>
    </app-dashboard-widget>
    <app-dashboard-widget [cols]="2" [rows]="3">
      <app-tractors-per-domain-widget [data]="kpi('tractors.per-domain')"></app-tractors-per-domain-widget>
    </app-dashboard-widget>
  </div>
  <div *ngIf="selectedGroup === 1" [@Fade]="selectedGroup === 1" class="grid p-3 grid-cols-8 gap-3">
    <app-dashboard-widget>
      <app-number-widget [value]="11" title="En Mouvement"></app-number-widget>
    </app-dashboard-widget>
    <app-dashboard-widget>
      <app-number-widget [value]="2" title="En Ralenti"></app-number-widget>
    </app-dashboard-widget>
    <app-dashboard-widget>
      <app-number-widget [value]="3" title="En Arrêt"></app-number-widget>
    </app-dashboard-widget>
    <app-dashboard-widget [cols]="2" [rows]="3">
      <app-tractors-per-domain-widget [data]="kpi('tractors.per-domain')"></app-tractors-per-domain-widget>
    </app-dashboard-widget>
    <app-dashboard-widget [cols]="3" [rows]="3">
      <app-tractors-avg-age-per-domain-widget [data]="kpi('tractors.avg-age')"></app-tractors-avg-age-per-domain-widget>
    </app-dashboard-widget>
    <app-dashboard-widget [cols]="3" [rows]="2">
      <app-tractors-engine-power-per-hectare-widget [data]="kpi('tractors.engine-power-per-hectare')"></app-tractors-engine-power-per-hectare-widget>
    </app-dashboard-widget>
    <app-dashboard-widget [cols]="2" [rows]="2">
      <app-tractors-proximity-widget [data]="kpi('tractors.proximity')"></app-tractors-proximity-widget>
    </app-dashboard-widget>
    <app-dashboard-widget [cols]="3" [rows]="2">
      <app-tractors-hectares-per-tractor-widget [data]="kpi('tractors.hectares-per-tractor')"></app-tractors-hectares-per-tractor-widget>
    </app-dashboard-widget>
    <app-dashboard-widget [cols]="3" [rows]="2">
      <app-tractors-fuel-consumption-widget [data]="kpi('tractors.fuel-consumption')"></app-tractors-fuel-consumption-widget>
    </app-dashboard-widget>
  </div>
  <div *ngIf="selectedGroup === 2" [@Fade]="selectedGroup === 2" class="grid p-3 grid-cols-4 gap-3">
    <app-dashboard-widget>
      test2<br>
      test<br>
      test<br>
    </app-dashboard-widget>
    <app-dashboard-widget>
      test<br>
      test<br>
      test<br>
    </app-dashboard-widget>
    <app-dashboard-widget>
      test<br>
      test<br>
      test<br>
    </app-dashboard-widget>
    <app-dashboard-widget>
      test<br>
      test<br>
      test<br>
    </app-dashboard-widget>
    <app-dashboard-widget>
      test<br>
      test<br>
      test<br>
    </app-dashboard-widget>
  </div>
</app-tab>
